import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import { Link } from "react-router-dom";
// import { showErrorToast, showSuccessToast } from './util/util';
import { ToastContainer } from "react-toastify";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#10374A",
    color: theme.palette.common.white,
    fontSize: '0.875rem',
    fontWeight: 600,
    padding: theme.spacing(1, 2),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0.5, 1),
      fontSize: '0.75rem',
    },
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: theme.spacing(1, 2),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0.5, 1),
      fontSize: '0.75rem',
    },
  },
}));

export default function CustomizedTables(props: any) {
  const inflightRequests = React.useRef<Map<string, Promise<any>>>(new Map());
  const [perModal, setPermModal] = React.useState(false);
  const [editItem, setEditItem] = React.useState<any>({});
  const [rows, setRows] = React.useState<any>([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const confirmDelete = (item: any) => {
    setEditItem(item);
    setPermModal(true);
  };
  const deleteItemPermenant = () => {
    if (props.deleteService && typeof props.deleteService === "function") {
      props
        .deleteService(editItem._id)
        .then((res: any) => {
          setPermModal(false);
          // showSuccessToast(res.message);
          loadData();
        })
        .catch((err: any) => {
          // showErrorToast(err.message);
        });
    } else {
      // showErrorToast("listService is not a valid promise.");
    }
  };

  const loadData = React.useCallback(async () => {
    if (props.listService && typeof props.listService === "function") {
      try {
        const key = props.listService.name || "listService";
        const map = inflightRequests.current;
        if (map.has(key)) {
          // reuse the in-flight promise
          const data = await map.get(key);
          setRows(Array.isArray(data) ? data : []);
          return;
        }

        const promise = props.listService();
        map.set(key, promise);
        try {
          const data = await promise;
          setRows(Array.isArray(data) ? data : []);
        } finally {
          map.delete(key);
        }
      } catch (err: any) {
        console.error("Error in listService:", err.message);

        // showErrorToast(err.messsage);
      }
    } else {
      console.error("listService is not a valid function.");

      // showErrorToast("listService is not a valid promise.");
    }
  }, [props.listService]);

  React.useEffect(() => {
    loadData();
  }, [loadData]);
  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          marginTop: "20px",
          maxHeight: { xs: 400, sm: 500, md: 600 },
          width: '100%',
          overflowX: 'auto',
          '& .MuiTable-root': {
            minWidth: { xs: 300, sm: 650, md: 'auto' }
          }
        }}
      >
        <Table stickyHeader size={isMobile ? "small" : "medium"}>
          <TableHead>
            <TableRow>
              {props.columns?.map((column: any) => (
                <StyledTableCell
                  key={column.id}
                  align={column.align}
                  style={{
                    minWidth: isMobile ? Math.max(column.minWidth * 0.7, 80) : column.minWidth,
                    maxWidth: isMobile ? 120 : 'none'
                  }}
                >
                  {column.label}
                </StyledTableCell>
              ))}
              {!props.isDashBoard && (
                <StyledTableCell
                  style={{
                    minWidth: isMobile ? 80 : 120,
                    width: isMobile ? 80 : 120
                  }}
                >
                  Action
                </StyledTableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows?.map((row: any, index: number) => {
              return (
                <TableRow key={row.id}>
                  {props.columns.map((column: any) => {
                    const cellValue = column.key === "images"
                      ? row[column.key]?.map((el: any, idx: number) => (
                        <img
                          src={el}
                          alt={`image-${idx}`}
                          width={isMobile ? 30 : 50}
                          height={isMobile ? 30 : 50}
                          style={{
                            objectFit: 'cover',
                            borderRadius: '4px',
                            marginRight: '4px'
                          }}
                          key={idx}
                        />
                      ))
                      : column.key === "area" && typeof row[column.key] === "object" && row[column.key]?.value
                        ? `${row[column.key].value} ${row[column.key].unit}`
                        : column.key === "price"
                          ? `₹${row[column.key]?.toLocaleString()}`
                          : typeof row[column.key] === "boolean"
                            ? row[column.key]
                              ? "Yes"
                              : "No"
                            : row[column.key] || "N/A";

                    return (
                      <TableCell
                        key={column.key}
                        sx={{
                          maxWidth: isMobile ? 120 : 'none',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: isMobile && column.key !== 'images' ? 'nowrap' : 'normal',
                          wordBreak: 'break-word'
                        }}
                      >
                        {cellValue}
                      </TableCell>
                    );
                  })}
                  {!props.isDashBoard && (
                    <TableCell>
                      <Box sx={{
                        display: "flex",
                        flexDirection: isMobile ? 'column' : 'row',
                        gap: isMobile ? 0.5 : 1,
                        alignItems: 'center'
                      }}>
                        {!props?.isUser && (
                          <IconButton
                            color="primary"
                            component={Link}
                            size={isMobile ? "small" : "medium"}
                            sx={{
                              backgroundColor: "#10374A",
                              color: "#FFF",
                              minWidth: isMobile ? 32 : 40,
                              minHeight: isMobile ? 32 : 40,
                              "&:hover": {
                                backgroundColor: "#08293D",
                              },
                            }}
                            to={props.editLink && props.editLink.includes('?')
                              ? `${props.editLink}&id=${row._id}`
                              : props.editLink ? `${props.editLink}/${row._id}?country=${props.country || 'india'}` : '#'
                            }
                            onClick={() => {
                              if (props.editLink) {
                                const editUrl = props.editLink.includes('?')
                                  ? `${props.editLink}&id=${row._id}`
                                  : `${props.editLink}/${row._id}?country=${props.country || 'india'}`;
                                console.log('Edit URL:', editUrl);
                              }
                              console.log('Edit Link:', props.editLink);
                              console.log('Row ID:', row._id);
                              console.log('Country:', props.country);
                            }}
                          >
                            <Edit fontSize={isMobile ? "small" : "medium"} />
                          </IconButton>
                        )}
                        <IconButton
                          color="secondary"
                          size={isMobile ? "small" : "medium"}
                          sx={{
                            backgroundColor: "#10374A",
                            color: "#FFFFFF",
                            minWidth: isMobile ? 32 : 40,
                            minHeight: isMobile ? 32 : 40,
                            "&:hover": {
                              backgroundColor: "#08293D",
                            },
                          }}
                          onClick={() => confirmDelete(row)}
                        >
                          <Delete fontSize={isMobile ? "small" : "medium"} />
                        </IconButton>
                      </Box>
                    </TableCell>
                  )}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog
        sx={{
          "& .MuiDialog-paper": {
            width: { xs: "95%", sm: "80%" },
            maxWidth: { xs: "none", sm: "xs" },
            maxHeight: 435,
            margin: { xs: 1, sm: 3 }
          }
        }}
        maxWidth="xs"
        open={perModal}
        fullWidth
      >
        <DialogTitle sx={{ fontSize: { xs: '1.1rem', sm: '1.25rem' } }}>
          Delete Confirmation
        </DialogTitle>
        <DialogContent dividers>
          <Typography sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>
            Are you sure want to delete this item permanently, once deleted
            cannot be reversed?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ padding: { xs: 1, sm: 2 } }}>
          <Button
            color="secondary"
            onClick={() => setPermModal(false)}
            size={isMobile ? "small" : "medium"}
          >
            Cancel
          </Button>
          <Button
            color="error"
            value="Delete"
            onClick={deleteItemPermenant}
            size={isMobile ? "small" : "medium"}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        style={{
          fontSize: isMobile ? '0.875rem' : '1rem'
        }}
      />
    </>
  );
}
